 $(document).ready( function(){
    $('#CustomerEmail, #CustomerPassword').keypress(function (e) {
      if (e.which == 13) {
        onSubmitLogin();
        return false;    //<---- Add this line
      }
    });
    
    $.fx.speeds.slow = 2000;
    
//     	$('#login-section-wrapper').fadeIn('slow');
    	$('#login-section-wrapper').show();
      	$('#create-section-wrapper').hide();
      	$('#RecoverPasswordForm').hide();
      	$('.login-lable').hide();
        $('.create-about-lable').show();
        $('.forgot-password-lable').show();
    
    function hideErrors () {
    	$('.login-email-error').addClass('hide');
  		$('.login-password-error').addClass('hide');
    }
    
	// login side bar code
    $('.login-lable').click(function(){
    	$('#login-section-wrapper').show();
      	$('#create-section-wrapper').hide();
      	$('#RecoverPasswordForm').hide();
      	$('.login-lable').hide();
        $('.create-about-lable').show();
        $('.forgot-password-lable').show();
      	hideErrors();
    });
    
    
    $('.create-about-lable').click( function(){
      	$('#create-section-wrapper').show();
    	$('#login-section-wrapper').hide();
      	$('#RecoverPasswordForm').hide();
      	$('.login-lable').show();
        $('.create-about-lable').hide();
        $('.forgot-password-lable').show();
      	hideErrors();
    } );
    
	$('.forgot-password-lable').click( function(){
      	$('#RecoverPasswordForm').show();
    	$('#login-section-wrapper').hide();
      	$('#create-section-wrapper').hide();
      	$('.login-lable').show();
        $('.create-about-lable').show();
        $('.forgot-password-lable').hide();
      	hideErrors();
    } );
    
    $('#cancel-forget-password').click( function(){
      	$('#login-section-wrapper').show();
    	$('#RecoverPasswordForm').hide();
      	$('#create-section-wrapper').hide();
      
      	$('.login-lable').hide();
        $('.create-about-lable').show();
        $('.forgot-password-lable').show();
      	hideErrors();
    });

    
  });
  function validateLoginForm() {
    var userEmail = $('#CustomerEmail').val();
    var userPassword = $('#CustomerPassword').val();
    var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i
    var valid = true;

    if(!pattern.test(userEmail))
    {
      $('#CustomerEmail').addClass('error');
      valid = false;
      $('.login-email-error').removeClass('hide');
    } else {
      $('#CustomerEmail').removeClass('error');
      $('.login-email-error').addClass('hide');
    }
    
    if(userPassword.trim().length < 6)
    {
      $('#CustomerPassword').addClass('error');
      valid = false;
      $('.login-password-error').removeClass('hide');
    } else {
      $('#CustomerPassword').removeClass('error');
      $('.login-password-error').addClass('hide');
    }
    return valid;
  }
  
  function validateRegisterForm() {
    var userEmail = $('#RegisterForm #-email').val();
    var userPassword = $('#RegisterForm #-password').val();
    var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i
    var valid = true;

    if(!pattern.test(userEmail))
    {
      $('#RegisterForm #-email').addClass('error');
      valid = false;
      $('.login-email-error').removeClass('hide');
    } else {
      $('#RegisterForm #-email').removeClass('error');
      $('.login-email-error').addClass('hide');
    }
    
    if(userPassword.trim().length < 6)
    {
      $('#RegisterForm #-password').addClass('error');
      valid = false;
      $('.login-password-error').removeClass('hide');
    } else {
      $('#RegisterForm #-password').removeClass('error');
      $('.login-password-error').addClass('hide');
    }
    return valid;
  }
  
  function validatePasswordRecoverForm() {
    var userEmail = $('#RecoverEmail').val();
    var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i
    var valid = true;

    if(!pattern.test(userEmail))
    {
      $('#RecoverEmail').addClass('error');
      valid = false;
      $('.login-email-error').removeClass('hide');
    } else {
      $('#RecoverEmail').removeClass('error');
      $('.login-email-error').addClass('hide');
    }
    
    return valid;
  }
  
  function onSubmitLogin(){
    if( validateLoginForm() ) {
    	$('#customer_login').submit();
    }
  }
  
  function onSubmitRegister(){
    if( validateRegisterForm() ) {
    	$('#RegisterForm').submit();
    }
  }
  
  function onSubmitPasswordRecover(){
    if( validatePasswordRecoverForm() ) {
    	$('#RecoverPasswordForm form').submit();
    }
  }